module.exports = __webpack_public_path__ + "img/V29.c08e7b7e.png";